import type { SxProps, Theme } from '@mui/material';

export const INPUT_LABEL_NUDGE = -8;

export const CHECKBOX_GROUP_FORM_CONTROL_LABEL_SX: SxProps<Theme> = {
  '& .MuiFormControlLabel-label': {
    fontSize: '14px',
  },
};

export const FORM_CONTROL_LABEL_ROW_SX: SxProps<Theme> = (theme) => ({
  display: 'flex',
  width: 'auto',
  boxSizing: 'border-box',
  margin: 0,
  marginInlineEnd: theme.spacing(1),
  flexWrap: 'wrap',
  rowGap: theme.spacing(0.5),
  '&:last-of-type': { marginInlineEnd: 0 },
});

export const FORM_CONTROL_LABEL_VERTICAL_SX: SxProps<Theme> = (theme) => ({
  display: 'flex',
  width: '100%',
  boxSizing: 'border-box',
  margin: 0,
  flexWrap: 'nowrap',
  columnGap: theme.spacing(0.5),
});
